var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import HttpConnection from './HttpConnection';
import WebSocketConnection from './WebSocketConnection';
import Event from './Event';
import Channel from './Channel';

var Jaws = function () {
  function Jaws(options) {
    _classCallCheck(this, Jaws);

    this.url = options.url;
    this.useWebSockets = options.useWebSockets != null ? options.useWebSockets : true;
    this.query = options.query;

    this.callbacks = {};
    this.channels = {};
    this.queue = {};
    this.triggerEvent = this.triggerEvent.bind(this);

    var supportsWebSockets = typeof window !== 'undefined' && 'WebSocket' in window && (typeof WebSocket === 'function' || (typeof WebSocket === 'undefined' ? 'undefined' : _typeof(WebSocket)) === 'object');

    if (options.useWebSockets && supportsWebSockets) {
      this.WebSocket = WebSocket;
    }

    this.connect();
  }

  _createClass(Jaws, [{
    key: 'reconnect',
    value: function reconnect() {
      var event, id, queue;

      this.disconnect();
      this.connect();
      queue = this.queue;

      for (id in queue) {
        event = queue[id];
        if (!event.isResult()) {
          this.triggerEvent(event);
        }
      }
      return this.reconnectChannels();
    }
  }, {
    key: 'disconnect',
    value: function disconnect() {
      if (this.conn) {
        this.conn.close();
        delete this.conn.conn;
        delete this.conn;
      }
      return this.state = 'disconnected';
    }
  }, {
    key: 'connect',
    value: function connect() {
      this.state = 'connecting';
      if (this.supportsWebSockets() && this.useWebSockets) {
        this.conn = new WebSocketConnection(this.url, this);
      } else {
        this.conn = new HttpConnection(this.url, this);
      }

      // TODO `this.conn` uses this.newMessage directly through the `dispatcher` instance variable.
      return this.conn.newMessage = this.newMessage;
    }
  }, {
    key: 'newMessage',
    value: function newMessage(message) {
      var results = [];
      var event;

      if (message === 'pong') {
        event = new Event('pong');
      } else {
        // TODO why message.type?
        event = new Event(message.type, message);
      }

      if (event.isResult()) {
        var ref = this.queue[event.id];
        if (ref != null) {
          ref.runCallbacks(event.success, event.data);
        }
        delete this.queue[event.id];
      } else if (event.isPong()) {
        this.dispatch(event);
      } else if (event.isMeta()) {
        this.dispatchChannel(event);
      } else if (event.isChannelToken()) {
        this.registerChannelToken(event);
      } else if (event.isChannel()) {
        this.dispatchChannel(event);
      } else {
        this.dispatch(event);
      }

      if (this.state === 'connecting' && event.name === 'client_connected') {
        results.push(this.connectionEstablished(event.data));
      }

      return results;
    }
  }, {
    key: 'connectionEstablished',
    value: function connectionEstablished(data) {
      this.state = 'connected';
      this.conn.flushQueue();

      // TODO this extension point should be documented or more transparent
      if (this.onOpen != null) {
        return this.onOpen(data);
      }
    }
  }, {
    key: 'bind',
    value: function bind(eventName, callback) {
      this.callbacks[eventName] = this.callbacks[eventName] || [];
      return this.callbacks[eventName].push(callback);
    }
  }, {
    key: 'unbind',
    value: function unbind(eventName) {
      return delete this.callbacks[eventName];
    }
  }, {
    key: 'triggerEvent',
    value: function triggerEvent(event) {
      this.queue[event.id] = this.queue[event.id] || event;
      if (this.conn) {
        this.conn.trigger(event);
      }
      return event;
    }
  }, {
    key: 'dispatch',
    value: function dispatch(event) {
      if (!this.callbacks[event.name]) return;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.callbacks[event.name][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var callback = _step.value;

          callback(event);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: 'subscribe',
    value: function subscribe(channelName, params) {
      var channel;
      if (this.channels[channelName] != null) {
        return this.channels[channelName];
      }

      channel = new Channel(channelName, params, this);
      this.channels[channelName] = channel;
      return channel;
    }
  }, {
    key: 'promise',
    value: function promise(params) {
      var event = new Event('subscribe', { params: params });
      var query = event.serializeParams(params);

      var req = fetch(this.url + '/components?' + query, {
        credentials: 'include'
      });

      return req.then(function (res) {
        return res.text();
      }).then(function (text) {
        try {
          return JSON.parse(text);
        } catch (e) {
          return text;
        }
      });
    }
  }, {
    key: 'unsubscribe',
    value: function unsubscribe(channelName) {
      // We can't unsubscribe a HttpConnection
      if (!this.useWebSockets) return;

      var channels, channel, token;
      channels = this.channels;

      for (token in channels) {
        channel = channels[token];
        if (channel.name === channelName) {
          channel.destroy();
          return delete channels[token];
        }
      }

      return;
    }
  }, {
    key: 'dispatchChannel',
    value: function dispatchChannel(event) {
      if (this.channels[event.id] == null) return;
      return this.channels[event.id].dispatch(event);
    }
  }, {
    key: 'registerChannelToken',
    value: function registerChannelToken(event) {
      var channels = this.channels;
      // Check for the old property name to avoid a ReferenceError in strict mode.
      if (channels.hasOwnProperty(event.channel)) {
        channels[event.id] = channels[event.channel];
        channels[event.id].name = event.channel;
        channels[event.id].token = event.id;

        delete channels[event.channel];
      }

      var channelTokenEvent = new Event('channel_token_received', {
        id: event.id
      });
      this.dispatchChannel(channelTokenEvent);
    }
  }, {
    key: 'supportsWebSockets',
    value: function supportsWebSockets() {
      return typeof this.WebSocket === 'function' || _typeof(this.WebSocket) === 'object';
    }
  }, {
    key: 'ping',
    value: function ping() {
      var ping = new Event('ping');
      return this.conn.trigger(ping);
    }
  }, {
    key: 'connectionStale',
    value: function connectionStale() {
      return this.state !== 'connected';
    }
  }, {
    key: 'reconnectChannels',
    value: function reconnectChannels() {
      var results = [];
      var callbacks = void 0;
      var channels = void 0;
      var channel = void 0;
      var token = void 0;
      channels = this.channels;

      for (token in channels) {
        channel = channels[token];
        callbacks = channel.callbacks;
        channel.destroy();
        delete this.channels[token];
        channel = this.subscribe(channel.name, channel.params);
        channel.callbacks = callbacks;
        results.push(channel);
      }
      return results;
    }
  }]);

  return Jaws;
}();

export default Jaws;